import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const bookAppointmentRoutes = {
  name: 'book-appointment',
  path: 'book-appointment',
  // `alias` is resolved against the SAME parent as `path`, so it carries the full prefix too:
  // the aliased URL stays `/book-appointment/list`, exactly as before this record was flattened.
  alias: 'book-appointment/list',
  component: () => import('./BookAppointment.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
